<template>
  <v-app>
    <nav>
      <v-app-bar app height="48" class="glass-nav" color="transparent">
        <img src="@/assets/logo.png" height="48" width="48" alt="logo" class="mr-2 ml-2" />
        <v-toolbar-title text="NPTU-Booking"></v-toolbar-title>
        <!-- <template v-slot:extension>
          <v-tabs>
            <v-tab v-if="!isAuthenticated" router to="/" text="Login"></v-tab>
            <v-tab v-if="isAuthenticated" router to="/dashboard" text="Calendar"></v-tab>

          </v-tabs>
        </template> -->
      </v-app-bar>
    </nav>
    <!-- set :rail to true bacause  want to fix sidebar if what to change set to rail -->
    <v-navigation-drawer v-model="drawer" :rail="true" permanent app class="glass-nav" color="transparent">
      <v-list>
        <v-list-item :prepend-avatar="user ? user.photoURL : 'no photo'" :title="user ? user?.name : 'Guest'">
          <template v-slot:append>
            <v-btn icon="mdi-chevron-left" variant="text" @click.stop="rail = !rail"></v-btn>
          </template>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>

      <v-list v-if="isAuthenticated && user.Role === 'admin'" density="compact" nav>
        <v-list-item :title="`ใช้งานในถานะ ${user.Role}`" prepend-icon="mdi-account-star"></v-list-item>
      </v-list>
      <v-list v-if="isAuthenticated" density="compact" nav>
        <v-list-item prepend-icon="mdi-logout" title="logout" @click="confirmLogout = true"></v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-main>
      <v-row v-if="isAuthenticated" justify="start" class="mt-0 pd-0">
        <v-col sm="2" md="1" class="mr-5">
          <v-btn variant="text" prepend-icon="mdi-view-list" size="medium" @click="drawer = !drawer"
            style="margin: -10px; margin-left: 30px">
            {{ drawer ? "ซ่อนเมนู" : "แสดงเมนู" }}
          </v-btn>
        </v-col>
        <!-- <v-col sm="2" md="1" align-self="end">
          <v-btn style="margin: -10px; margin-left: 30px">
            {{ user.displayName ? user.displayName : "" }}</v-btn
          ></v-col 
        >-->

      </v-row>

      <div class="div-box">
        <router-view v-slot="{ Component }">
          <transition name="slide-y-transition" mode="out-in">
            <component :is="Component" />
          </transition>
        </router-view>
      </div>
      <v-snackbar v-model="snackbar" multi-line>
        {{ snackbarMessage }}

        <template v-slot:actions>
          <v-btn :color="snackbarColor" variant="text" @click="snackbar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
      <!--  -->
      <v-dialog v-model="confirmLogout" max-width="400">
        <v-card>
          <v-card-title class="headline">Confirm Logout</v-card-title>
          <v-card-text>Are you sure you want to log out?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey-darken-1" text @click="confirmLogout = false">Cancel</v-btn>
            <v-btn color="red-darken-2" text @click="performLogout">Logout</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!--  -->
    </v-main>
  </v-app>
</template>
<script setup>
import { ref } from "vue";
import router from "@/router";
import { auth } from "@/firebaseConfig";

import { useAuth } from "@/composable";
const {
  drawer,
  user,
  rail,
  logout,
  isAuthenticated,
  snackbar,
  snackbarColor,
  snackbarMessage,
} = useAuth();
const confirmLogout = ref(false);
const performLogout = async () => {
  confirmLogout.value = false; // Close the dialog
  await logout(); // Call the global logout function from useAuth
};
</script>

<style>
* {
  box-sizing: border-box;
}

#app,
.v-application {
  font-family: 'Prompt', 'Inter', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background: linear-gradient(135deg, #ffe4e1 0%, #ffc0cb 100%) !important;
  min-height: 100vh;
}

.v-application__wrap {
  min-height: 100vh;
}

nav {
  text-align: start;
  padding: 0px;
}

body {
  margin: 0;
  padding: 0;
}

.div-box {
  overflow: auto;
  margin: 1.5em;
  background: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.5);
  padding: 20px;
  height: 80vh;
  border-radius: 24px;
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.1);
}

@media (max-width: 600px) {
  .div-box {
    margin: 0;
    padding: 2px;
    height: 85vh;
    border-radius: 8px;
  }
}

.glass-nav {
  background: rgba(255, 255, 255, 0.7) !important;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.3) !important;
  border-right: 1px solid rgba(255, 255, 255, 0.3) !important;
  box-shadow: 0 4px 16px 0 rgba(31, 38, 135, 0.05) !important;
}
</style>
